import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import NewWindow from 'react-new-window'

import MemberListItem from './MemberListItem';
import ChatBoxTabsWindow from './ChatBoxTabsWindow';
import memberActions from '../actions/member_actions';
import chatActions from '../actions/chat_actions';
import userActions from '../actions/user_actions';
import windowActions from '../actions/window_actions';

export class MemberList extends Component {
    constructor(props) {
        super(props);
        // this.textField = React.createRef();
        this.state = {
            hub: {},
            unreadMessages: {},
            features: {
                width: 450,
                height: 450,
                top: window.screenTop,
                left: window.screenLeft + 205, // window.innerWidth + 5, // some space + 5 (local)
                screenX: window.screenX + 205, // window.innerWidth + 5, // some space + 5
                screenY: window.screenY,
                alwaysRaised: "yes",
                alwaysOnTop: true,
            },
            chatBoxTabsOpen: false,
            recipients: [], // list of recipients obj, passed up from MemberListItem
            disableUnread: false,
            logoutClicked: false,
            hiddenTabs: [],
            displayedTabs: [],
            focusedUserTab: {}
        };
    };

    componentDidMount() {
        this.state = {};
        this.props.populateMemberList();
        console.log("MemberList - user");
        this.props.getUnreadMessages();  // pulls all messages from history and treats as unread messages
        const unreadMessages = [];
        setTimeout(function () {
            if (localStorage.getItem("token") !== null) {
                this.props.hub.on('NewMessage', (message => {
                    if (message.payload.userId !== this.props.profile.id && !this.state.recipients.includes(message.payload.userId)) {
                        // var sender = this.props.memberIdMap[message.payload.userId];
                        // this.addNewRecipient(sender, false); // called every time a new message is received
                        if (this.state.recipients.length == 0) {
                            console.log("[MemberList] this.props.shouldTurnFlashOn before flashstart", this.props.shouldTurnFlashOn); // false
                            this.flashNotification('teamx', 'flashstart');
                            this.props.setIconFlash(true);
                            console.log("[MemberList] this.props.shouldTurnFlashOn after flashstart", this.props.shouldTurnFlashOn); // true
                        }

                        var sender = this.props.memberIdMap[message.payload.userId]; ///////////////////////////////////////////////////////
                        for (var i = 0; i < this.state.recipients.length; i++) {
                            if (this.state.recipients[i]['id'] === sender['id']) {
                                console.log("Already exists");
                                if (i > 5) {
                                    console.log("Move this person to first tab");
                                    var recipientsCopy = this.state.recipients;
                                    recipientsCopy.unshift(recipientsCopy.splice(i, 1)[0]);
                                    console.log("recipientsCopy", recipientsCopy);
                                    this.setState({ recipients: recipientsCopy });
                                    this.props.updateTabIndex(this.props.currentTabIndex + 1);
                                    window.open("", "chatBoxWindow", "location=0,width=450,height=450").focus();
                                    // window.open("", "ChatBoxWindow").focus();
                                    return;
                                }
                                return;
                            }
                        }
                        console.log("Doesn't exist");
                        console.log("windowFocus1");
                        window.open("", "chatBoxWindow", "location=0,width=450,height=450").focus();
                        // setTimeout(function () { window.open("", "ChatBoxWindow").focus(); }, 200);

                        this.addNewRecipient(sender, false, false);
                        if (this.state.recipients.length === 1) {
                            this.props.updateTabIndex(0);
                        }
                    }
                }))
            }
            ////////////////////////////////////////////////////////////////////

            console.log(this.props.unreadMessages);
            console.log(this.props.members);
            if (this.props.profile.id !== undefined) {
                // Open Chat Window When Unread Messages Are Present
                this.props.members.map(member => {
                    console.log(member.id);
                    console.log(this.props.unreadMessages[member.userId]);
                    if (this.props.unreadMessages[member.id]) unreadMessages.push(member);
                });
                if (unreadMessages.length == 0) {
                    // Populate chatbox with user info if no unread messages
                    this.props.members.map(member => {
                        if (this.props.profile.id === member.id)
                            unreadMessages.push(member);
                    });
                }
                for (var i = 0; i < unreadMessages.length; i++) {
                    this.props.updateTabIndex(i);
                }
                console.log("unreads after process...");
                console.log(unreadMessages);
                this.setState({ chatBoxTabsOpen: false }, () => {
                    this.setState({ recipients: unreadMessages, chatBoxTabsOpen: true }, () => { this.props.updateTabIndex(this.state.recipients.length - 1) });
                    this.props.setChatDisplay(true);
                });
                console.log(this.state.recipients);
            }

            ////////////////////////////////////////////////////////////////////////////
        }.bind(this), 5000);
        ////////////////////////////////////////////////////////////////////////////
        // Position Chat Window Next to Member List

        this.setState({
            features: {
                width: 450,
                height: 450,
                top: window.screenTop,
                left: window.screenLeft + 205, // window.innerWidth + 5, // some space + 5 (local)
                screenX: window.screenX + 205, // window.innerWidth + 5, // some space + 5
                screenY: window.screenY,
                alwaysRaised: "yes",
                alwaysOnTop: true,
            }
        });

        //////////////////////////////////////////////////////////////////////////////////
    };

    memberIsClicked = (newRecipient, shouldRefresh, shouldSetToEnd = false, moveToFront = false) => {
        console.log("newRecipient", newRecipient);
        console.log("shouldRefresh", shouldRefresh);
        console.log("shouldSetToEnd", shouldSetToEnd);
        console.log("moveToFront", moveToFront);
        console.log("this.state.recipients", this.state.recipients); // contains the whole dropdown list of objs

        for (var i = 0; i < this.state.recipients.length; i++) {
            if (this.state.recipients[i]['id'] === newRecipient['id']) {
                console.log("Already exists");
                if (i > 5) {
                    console.log("Move this person to first tab");
                    var recipientsCopy = this.state.recipients;
                    recipientsCopy.unshift(recipientsCopy.splice(i, 1)[0]);
                    console.log("recipientsCopy", recipientsCopy);
                    this.setState({ recipients: recipientsCopy });
                    this.props.updateTabIndex(0);
                    console.log("windowFocus2");
                    window.open("", "chatBoxWindow", "location=0,width=450,height=450").focus();
                    // window.open("", "ChatBoxWindow").focus();
                    return;
                }
                this.props.updateTabIndex(i);
                console.log("windowFocus3");
                window.open("", "chatBoxWindow", "location=0,width=450,height=450").focus();
                // window.open("", "ChatBoxWindow").focus();

                return;
            }
        }
        console.log("Doesn't exist");
        this.addNewRecipient(newRecipient, shouldRefresh, shouldSetToEnd);
        this.props.updateTabIndex(0);
        window.open("", "chatBoxWindow", "location=0,width=450,height=450").focus();
    };

    addNewRecipient = (newRecipient, shouldRefresh, shouldSetToEnd = false) => {
        console.log("[MemberList.js] addNewRecipient called");
        console.log("[MemberList.js] newRecipeint:", newRecipient);
        var recipientsCopy = [...this.state.recipients];

        // if chat window is already open, focus on existing chat window

        if (recipientsCopy.length >= 1) {
            console.log("windowFocus4");
            // window.open("", "ChatBoxWindow").focus();
        }
        var alreadyThere = false;
        for (var i = 0; i < recipientsCopy.length; i++) {
            if (recipientsCopy[i]['id'] === newRecipient['id']) {
                alreadyThere = true;
                // this.props.updateTabIndex(i);
                // if (shouldSetToEnd) {
                return;
                // }
            }
        }

        var updatedRecipients = recipientsCopy;

        // if user object already in recipients list, remove them and then add them to the front
        if (!alreadyThere) {
            // var index = recipientsCopy.indexOf(newRecipient);
            // recipientsCopy.splice(index, 1);
            // updatedRecipients = recipientsCopy.concat([newRecipient]);
            if (recipientsCopy.length >= 5) {
                this.removeRecipient(recipientsCopy[recipientsCopy.length - 1]);
                recipientsCopy.splice(4,1);
            }
            updatedRecipients = [newRecipient].concat(recipientsCopy);
        }

        if (shouldRefresh && localStorage.token !== "" && localStorage.token !== null) { // chat box still opens after logging out
            console.log("refreshed!");

            //this.props.setChatDisplay(false); 
            //this.props.setChatDisplay(true);
            this.setState({ chatBoxTabsOpen: false }, () => {
                this.setState({ recipients: updatedRecipients, chatBoxTabsOpen: true }, () => { });
                this.props.setChatDisplay(true);

            });
        } else {
            this.setState({ recipients: updatedRecipients, chatBoxTabsOpen: true }, () => { });
            this.props.setChatDisplay(true);
        }
        //this.props.updateTabIndex(0);
        this.props.updateTabIndex(this.props.currentTabIndex + 1);
        window.open("", "chatBoxWindow", "location=0,width=450,height=450").focus();
    };

    flashNotification = (protocol, action, params) => {
        localStorage.setItem("justLoggedIn", true);
        console.log("[Memberlist.js] flash protocol called");
        var e = document.createElement('a');
        e.id = 'flashNotification';
        var strParams = "";
        if (typeof params !== 'undefined') {
            Object.keys(params).forEach(function (key) {
                strParams += strParams != "" ? '&' : '';
                strParams += key + '=' + encodeURI(params[key]);
            });
        }
        e.href = strParams.length > 0 ? protocol + '://' + action + '?' + strParams : protocol + '://' + action;
        document.getElementsByTagName('body')[0].appendChild(e);
        e.click();
        e.parentNode.removeChild(e);
    };

    removeRecipient = (recipientToRemove) => {
        var recipientToRemoveId = recipientToRemove.id; // extract recipientToRemove id
        console.log("recipientToRemoveId++++++", recipientToRemoveId);

        var recipientsCopy = this.state.recipients; // arr of user objs
        var recipientsIdArr = [];
        for (var i = 0; i < recipientsCopy.length; i++) { // iterate through arr & extract user ids into arr
            recipientsIdArr.push(recipientsCopy[i].id);
        }

        //var index = recipientsCopy.indexOf(recipientToRemove);
        var index = recipientsIdArr.indexOf(recipientToRemoveId);
        if (index > -1) { // if obj exists in the arr of objs
            recipientsCopy.splice(index, 1);
        }
        if (recipientsCopy.length === 0) {
            this.setState({ chatBoxTabsOpen: false });
            this.props.setChatDisplay(false);
        }
        // this.setState({ recipients: recipientsCopy });

        setTimeout(function () {
            if (this.state.chatBoxTabsOpen) {
                this.props.updateTabIndex(0);
            }
        }.bind(this), 50);
    };

    closeChatBoxTabs = () => {
        this.setState({ recipients: [], chatBoxTabsOpen: false });
        this.props.setChatDisplay(false);
    };

    passDisableUnreadToChild = () => {
        this.setState({ disableUnread: true }, () => { console.log("[MemberList.js] this.state.disableUnread", this.state.disableUnread); });
    };

    render() {
        const inOffice = []; //online
        const outOffice = []; //offline
        this.props.members.map((member) => {
            if (member.inOffice === true) {
                inOffice.push( //online
                    <MemberListItem
                        member={member}
                        key={member.id}
                        hasUnreadMessage={this.props.unreadMessages[member.id] ? true : false}
                        callbackFromParent={this.memberIsClicked}//{this.addNewRecipient}
                        disableUnread={this.state.disableUnread}
                    />
                );
            }
            else if (member.inOffice === false) {
                outOffice.push( //offline
                    <MemberListItem
                        member={member}
                        key={member.id}
                        hasUnreadMessage={this.props.unreadMessages[member.id] ? true : false}
                        callbackFromParent={this.memberIsClicked}//{this.addNewRecipient}
                        disableUnread={this.state.disableUnread}
                    />
                );
            }
        });
        let chatBoxTabsWindow;
        if (this.props.shouldDisplayChat === true) { //focusChatBox={this.state.focusChatBox}
            chatBoxTabsWindow =
                <NewWindow id="test" name={'chatBoxWindow'} onUnload={this.closeChatBoxTabs} features={this.state.features} title={'TeamX'}> {/*center={'parent'} center={'screen'}*/ /*alwaysRaised={'yes'}*/}
                    <ChatBoxTabsWindow
                        recipients={this.state.recipients}
                        callbackFromParentRemove={this.removeRecipient}
                        callbackFromParent={this.memberIsClicked} //{this.addNewRecipient}
                        onClick={this.passDisableUnreadToChild} />
                </NewWindow>;
        } else {
            chatBoxTabsWindow = <div></div>;
        }

        //if (this.props.logoutclicked) {
        //  console.log("logout clicked MemberList.js");
        //  this.setstate({ logoutclicked: true }, () => {
        //    this.closechatboxtabs();
        //    this.setstate({ logoutclicked: false });
        //  });
        //}
        return (
            <div style={{ width: '100% !important' }}>
                <h5 style={{ backgroundColor: '#e5e5e5', padding: '6px', margin: '0px' }}><b><i>Online</i></b></h5>
                <ul style={{ padding: '2px', margin: '0px' }}>{inOffice}</ul>
                <h5 style={{ backgroundColor: '#e5e5e5', padding: '6px', margin: '0px' }}><b><i>Offline</i></b></h5>
                <ul style={{ padding: '2px', margin: '0px' }}>{outOffice}</ul>
                {chatBoxTabsWindow}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        hub: state.hub,
        members: state.members,
        unreadMessages: state.unreadMessages,
        memberIdMap: state.memberIdMap,
        profile: state.profile,
        shouldDisplayChat: state.shouldDisplayChat,
        currentTabIndex: state.currentTabIndex,
        shouldTurnFlashOn: state.shouldTurnFlashOn,
        // openChatBoxTabsWindow: state.openChatBoxTabsWindow,
    };
}

const mapDispatchToProps = dispatch => ({
    updateTabIndex: (tabIndex) => dispatch(chatActions['TAB_INDEX'](tabIndex)),
    populateMemberList: () => dispatch(memberActions['FETCH_MEMBERS']()),
    setChatDisplay: shouldDisplay => dispatch(windowActions['SET_CHAT_DISPLAY'](shouldDisplay)),
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
    getUnreadMessages: () => dispatch(userActions['UNREAD_MESSAGE_FETCH']()),
    getUnreadMessageUser: () => dispatch(userActions['UNREAD_MESSAGE_USER_FETCH']()),
    //updateChatBoxTabsWindow: () => dispatch(chatWindowActions['CLOSE_CHATWINDOW']()),
})

export default connect(mapStateToProps, mapDispatchToProps)(MemberList);



// WEBPACK FOOTER //
// ./src/components/MemberList.js